import template from './checklistsList.template.html';

export default {
  template,
  bindings: {
    checklists: '=',
    onClick: '&',
    onChange: '&',
    onReady: '&'
  },
controller: class controller {
    constructor($rootScope, $filter, $mdMedia, listServiceNew) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.list = new listServiceNew.List();
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.list.setData(
          $filter('stStartingLetter')(ctrl.checklists, ctrl.list.getGroupingByFirstLetter())
        );
        ctrl.onReady({ list: ctrl.list });
      };
      ctrl.click = function ($event, data) {
        ctrl.onClick({ event: $event, data });
      };
      ctrl.select = function (data) {
        const isSelected = ctrl.list.setSelected(data);
        ctrl.onChange({ list: ctrl.list, data, isSelected });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      ctrl.$onChanges = function (changes) {
        if (changes.checklists && changes.checklists.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
